module.exports = __webpack_public_path__ + "assets/img/24_323.82b8d975.jpg";